import { THandleSendParams } from '@/components/pages/ChatPage/types';
import { EFaqsCategoryIcons } from '@/store/faq/config';
import { TFAQsItem } from '@/store/faq/types';

// INFO: Which entry point to the Question Panel the composer slot offers. An Unstarted Thread gets
// the Shortcut Bar; once a message has been sent the Panel Toggle takes over for the whole thread.
export enum EQuestionPanelEntryMode {
  SHORTCUT_BAR = 'shortcutBar',
  PANEL_TOGGLE = 'panelToggle',
}

// INFO: A one-shot focus request raised by a state transition and cleared by whichever component
// owns the target. It records where focus must go next, never where focus currently is.
export enum EQuestionPanelFocusTarget {
  PANEL = 'panel',
  SHORTCUT = 'shortcut',
  TOGGLE = 'toggle',
}

export type TUseQuestionPanelOptions = {
  shouldShowEmptyState?: boolean;
  isOnboarding?: boolean;
  isLoading?: boolean;
  handleSend?: (params: THandleSendParams) => Promise<void>;
};

export type TQuestionPanelState = {
  activeCategory: EFaqsCategoryIcons | null;
  hasDraft: boolean;
  isPanelOpen: boolean;
  isShortcutBarVisible: boolean;
  isPanelToggleVisible: boolean;
  originCategory: EFaqsCategoryIcons | null;
  pendingFocus: EQuestionPanelFocusTarget | null;
  searchValue: string;
  faqsList: TFAQsItem[];
  selectCategory: (category: EFaqsCategoryIcons) => void;
  setFilterFromPanel: (category: EFaqsCategoryIcons | null) => void;
  setSearchValue: (value: string) => void;
  closePanel: () => void;
  openPanel: () => void;
  selectQuestion: (item: TFAQsItem) => Promise<void>;
  consumePendingFocus: () => void;
};

export type TExampleQuestionPanelProps = {
  isOpen: boolean;
  isOnboarding: boolean;
  // INFO: True while the panel is docked below the Chat Composer in the Centred Layout, where it fills a
  // reserved block instead of growing to fit its content.
  isBelowComposer: boolean;
  activeCategory: EFaqsCategoryIcons | null;
  searchValue: string;
  faqsList: TFAQsItem[];
  shouldClaimFocus: boolean;
  onClose: () => void;
  onFilterChange: (category: EFaqsCategoryIcons | null) => void;
  onSearchChange: (value: string) => void;
  onSelectQuestion: (item: TFAQsItem) => void;
  onFocusClaimed: () => void;
};
